export default function buildGetUserOrgTasks({
    apiTools
}) {
    return async function getUserOrgTasks(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `org/task/user` // differs from standard unfortunately
        })
       
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}